"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGridShorthand = exports.openGridShorthand = void 0;
var tslib_1 = require("tslib");
var tokenizers_1 = require("../../tokenizers");
var shorthands_ast_evaluation_1 = require("../shorthands-ast-evaluation");
var shorthand_css_data_1 = require("../shorthand-css-data");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var grid_template_shorthand_1 = require("./grid-template-shorthand");
var shorthand_parser_errors_1 = require("../shorthand-parser-errors");
var getGridShorthandParts = function () {
    return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read((0, grid_template_shorthand_1.getGridTemplateShorthandParts)()), false), [
        { prop: 'grid-auto-flow', dataType: css_data_types_1.gridAutoFlowDataType, multipleItems: true },
        { prop: 'grid-auto-rows', dataType: css_data_types_1.gridAutoRowsDataType, multipleItems: true },
        { prop: 'grid-auto-columns', dataType: css_data_types_1.gridAutoColumnsDataType, multipleItems: true },
    ], false);
};
var isSeperator = function (astNodes, index) { return (0, css_data_types_1.seperatorPredicate)()(astNodes[index].value); };
var getTrackSizeLength = function (astNodes, index) {
    return astNodes.length > index ? Number((0, css_data_types_1.asteriskPredicate)(css_data_types_1.trackSizePredicate)(astNodes[index].value, index, astNodes)) : 0;
};
var getAutoFlowText = function (axis, dense) {
    if (dense === void 0) { dense = false; }
    return (axis === 'row' ? css_data_types_1.GRID_AUTO_FLOW_ROW_KEYWORD : css_data_types_1.GRID_AUTO_FLOW_COLUMN_KEYWORD) +
        (dense ? " ".concat(css_data_types_1.GRID_AUTO_FLOW_DENSE_KEYWORD) : '');
};
var openGridShorthandAutoFlow = function (axis, astNodes, autoFlowMatch, trackSizeLength, rowsLength) {
    var autoFlowIndex = autoFlowMatch.index, autoFlowLength = autoFlowMatch.length;
    var opened = {};
    if (axis === 'row') {
        opened['grid-template-columns'] = astNodes.slice(autoFlowLength + trackSizeLength + 1);
        if (trackSizeLength > 0) {
            opened['grid-auto-rows'] = astNodes.slice(autoFlowLength, autoFlowLength + trackSizeLength);
        }
    }
    else {
        opened['grid-template-rows'] = astNodes.slice(0, rowsLength);
        if (trackSizeLength > 0) {
            opened['grid-auto-columns'] = astNodes.slice(autoFlowIndex + autoFlowLength);
        }
    }
    opened['grid-auto-flow'] = (0, shorthands_ast_evaluation_1.codeToEvaluatedAst)((0, tokenizers_1.createCssValueAST)(getAutoFlowText(axis, autoFlowLength === 2)));
    return opened;
};
var openGridShorthandTemplateRowsSyntax = function (astNodes, autoFlowMatch) {
    var autoFlowIndex = autoFlowMatch.index, autoFlowLength = autoFlowMatch.length;
    if (autoFlowIndex <= 1 || !isSeperator(astNodes, autoFlowIndex - 1)) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid', 'grid-auto-flow');
    }
    var rowsMatch = (0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.gridTemplateRowsDataType, astNodes, 0);
    if (!rowsMatch || Number(rowsMatch) !== autoFlowIndex - 1) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid', 'grid-template-rows');
    }
    var trackSizeLength = getTrackSizeLength(astNodes, autoFlowIndex + autoFlowLength);
    if (trackSizeLength !== astNodes.length - autoFlowIndex - autoFlowLength) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid', 'grid-auto-flow');
    }
    return openGridShorthandAutoFlow('column', astNodes, autoFlowMatch, trackSizeLength, Number(rowsMatch));
};
var openGridShorthandTemplateColumnsSyntax = function (astNodes, autoFlowMatch) {
    var autoFlowLength = autoFlowMatch.length;
    var trackSizeLength = getTrackSizeLength(astNodes, autoFlowLength);
    if (!isSeperator(astNodes, autoFlowLength + trackSizeLength)) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid', 'grid-auto-flow');
    }
    var columnsMatch = (0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.gridTemplateColumnsDataType, astNodes, autoFlowLength + trackSizeLength, css_data_types_1.DataTypeType.GridTemplateRows);
    if (!columnsMatch || Number(columnsMatch) !== astNodes.length - autoFlowLength - trackSizeLength) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid', 'grid-template-columns');
    }
    return openGridShorthandAutoFlow('row', astNodes, autoFlowMatch, trackSizeLength);
};
// grid
var openGridShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'grid',
        singleKeywordPart: {
            prop: 'grid',
            dataType: css_data_types_1.gridSingleValueDataType,
            partOpener: (0, shorthand_parser_utils_1.singleKeywordShorthandOpener)(shorthand_css_data_1.GRID_KEYWORD_VALUE_MAP, true),
        },
        parts: getGridShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) {
            var autoFlowMatch = (0, css_data_types_1.findPredicateIndexMatch)(astNodes, css_data_types_1.gridAutoFlowPredicate);
            return (autoFlowMatch
                ? autoFlowMatch.index > 0
                    ? openGridShorthandTemplateRowsSyntax(astNodes, autoFlowMatch)
                    : openGridShorthandTemplateColumnsSyntax(astNodes, autoFlowMatch)
                : (0, grid_template_shorthand_1.openGridTemplateShorthandSyntax)()(astNodes, api, parts));
        },
    });
};
exports.openGridShorthand = openGridShorthand;
var getParsedOpenedAutoFlow = function (opened) {
    var _a;
    var openedAutoFlow = opened['grid-auto-flow'];
    var openedAutoArray = (Array.isArray(openedAutoFlow) ? openedAutoFlow : [openedAutoFlow]);
    if (!(0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-template-areas', css_data_types_1.gridTemplateAreasDataType) || openedAutoArray.length < 1) {
        throw new shorthand_parser_errors_1.CannotCloseGridError();
    }
    var parsedAutoFlow = openedAutoArray.reduce(function (autoFlow, _a) {
        var value = _a.value;
        switch (value.text) {
            case css_data_types_1.GRID_AUTO_FLOW_ROW_KEYWORD:
                if (autoFlow.axis === undefined) {
                    autoFlow.axis = 'row';
                    return autoFlow;
                }
                break;
            case css_data_types_1.GRID_AUTO_FLOW_COLUMN_KEYWORD:
                if (autoFlow.axis === undefined) {
                    autoFlow.axis = 'column';
                    return autoFlow;
                }
                break;
            case css_data_types_1.GRID_AUTO_FLOW_DENSE_KEYWORD:
                if (autoFlow.dense === undefined) {
                    autoFlow.dense = true;
                    return autoFlow;
                }
                break;
        }
        throw new shorthand_parser_errors_1.CannotCloseGridError();
    }, {});
    if (parsedAutoFlow.axis === undefined && parsedAutoFlow.dense === undefined) {
        throw new shorthand_parser_errors_1.CannotCloseGridError();
    }
    return { axis: (_a = parsedAutoFlow.axis) !== null && _a !== void 0 ? _a : 'row', dense: !!parsedAutoFlow.dense };
};
var closeGridShorthandAutoFlowSyntax = function (autoFlow, isAutoRowsInitial, isAutoColumnsInitial) {
    return function (opened, api, detachExpression) {
        var axis = autoFlow.axis, dense = autoFlow.dense;
        if ((axis === 'row' &&
            (!(0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-template-rows', css_data_types_1.gridTemplateRowsDataType) || !isAutoColumnsInitial)) ||
            (axis === 'column' &&
                (!(0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-template-columns', css_data_types_1.gridTemplateColumnsDataType) || !isAutoRowsInitial))) {
            throw new shorthand_parser_errors_1.CannotCloseGridError();
        }
        return [(0, tokenizers_1.valueTextNode)(css_data_types_1.GRID_AUTO_FLOW_KEYWORD)]
            .concat(dense ? [(0, tokenizers_1.valueTextNode)(css_data_types_1.GRID_AUTO_FLOW_DENSE_KEYWORD)] : [])
            .concat((0, shorthand_parser_utils_1.getOpenedNode)(opened[axis === 'row' ? 'grid-auto-rows' : 'grid-auto-columns'], api, detachExpression));
    };
};
var closeGridShorthand = function () {
    return function (opened, api, detachExpression) {
        var isAutoRowsInitial = (0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-auto-rows', css_data_types_1.gridAutoRowsDataType);
        var isAutoColumnsInitial = (0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-auto-columns', css_data_types_1.gridAutoColumnsDataType);
        if ((0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-auto-flow', css_data_types_1.gridAutoFlowDataType) &&
            isAutoRowsInitial &&
            isAutoColumnsInitial) {
            return (0, grid_template_shorthand_1.closeGridTemplateShorthand)()(opened, api, detachExpression);
        }
        var autoFlow = getParsedOpenedAutoFlow(opened);
        var closedAutoFlowAst = closeGridShorthandAutoFlowSyntax(autoFlow, isAutoRowsInitial, isAutoColumnsInitial)(opened, api, detachExpression);
        var closedTemplateAxisAst = (0, shorthand_parser_utils_1.getOpenedNode)(opened[autoFlow.axis === 'row' ? 'grid-template-columns' : 'grid-template-rows'], api, detachExpression);
        var slashNode = tslib_1.__assign(tslib_1.__assign({}, (0, tokenizers_1.valueTextNode)('/')), { type: '/' });
        return (0, shorthand_parser_utils_1.fixAstNodesPositions)(autoFlow.axis === 'row'
            ? closedAutoFlowAst.concat(slashNode).concat(closedTemplateAxisAst)
            : closedTemplateAxisAst.concat(slashNode).concat(closedAutoFlowAst), api);
    };
};
exports.closeGridShorthand = closeGridShorthand;
//# sourceMappingURL=grid-shorthand.js.map